<router-outlet></router-outlet>
<ssc-loader class="loading"></ssc-loader>